import React                          from "react";
import { useDispatch, useSelector }   from "react-redux";
import classnames                     from 'classnames';

import BomErrors                      from "./bom_errors/BomErrors";
import BomSummary                     from "./bom_summary/BomSummary";
import BomTable                       from "./bom_table/BomTable";
import Messages                       from 'pu-react/components/Messages';
import QuoteProgress                  from "./QuoteProgress";

import { changeBomSelectedBoardQty }  from "../../bomSlice";
import { QUOTING_BOM_PARTS, QUOTED }  from "product_tabs/tab_parts/data/BomStatus";
import { selectDataForQuoteView }     from "product_tabs/tab_parts/selector/selectors";

const BomQuote = (props) => {
  const dispatch = useDispatch();

  const { 
    bom_line_items,
    bom_status,
    messages,
    selected_board_qty,
    onShowSearchModal, 
    onShowMoreOptions,
  } = props;

  const {
    quote_step,
    quote_total_steps,
    board_qtys,
    totals,
    base_totals,
    shipping,
    markups,
    tariffs,
    initial_selected_board_qty,
  } = useSelector(selectDataForQuoteView);

  const onSelectBoardQty = (e) => {
    if(e.target.value < initial_selected_board_qty) return
    dispatch(changeBomSelectedBoardQty(e.target.value))
  }

  return (
    <>
      <div id="bom-quote">
        <Messages messages={messages} />
        <div className="row mb-3">
          <div className="col-12 col-md-5">
            <QuoteProgress 
              show={bom_status == QUOTING_BOM_PARTS}
              step={quote_step}
              total_steps={quote_total_steps}/>
            {bom_status == QUOTED && 
              <span className="d-inline-flex px-2 py-1 fw-semibold text-success bg-success bg-opacity-10 border border-success border-opacity-10 rounded-2">
                QUOTED!
              </span>
            }
          </div>  
          <div className="col-12 col-md-4"/>
          <div className="col-12 col-md-3">
            { board_qtys && board_qtys.filter((board_qty) => board_qty).length > 0 && 
              <div className="row">
                <div className="col-sm-5 text-end">
                  <label># of Board</label>
                </div>
                <div className="col-sm-7">
                  <select className="form-select form-select-sm"
                    onChange={onSelectBoardQty}
                    value={selected_board_qty || ''}>
                      {board_qtys.filter(board_qty => board_qty >= initial_selected_board_qty).map((board_qty) => (
                        <option 
                          key={"board-qty-" + board_qty}
                          value={board_qty}>
                          {board_qty}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
            }
          </div>  
        </div>
        
        <div id="bom-quote-table"
          className={classnames("table-responsive", {
            "custom-height": bom_line_items && bom_line_items.length > 7,
          })}>
          <BomTable
            board_qtys={board_qtys}
            selected_board_qty={selected_board_qty} 
            bom_line_items={bom_line_items}
            markups={markups}
            onShowSearchModal={onShowSearchModal}
            onShowMoreOptions={onShowMoreOptions}/>
        </div>
        <BomErrors 
          bom_line_items={bom_line_items} 
          selected_board_qty={selected_board_qty}/>
        <BomSummary 
          base_totals={base_totals}
          markups={markups}
          shipping={shipping}
          tariffs={tariffs}
          totals={totals} 
          selected_board_qty={selected_board_qty}/>
      </div>
      
    </>
  )
}

export default BomQuote;